import { render, staticRenderFns } from "./ReleaseNotesModal.vue?vue&type=template&id=4d1faad0&"
import script from "./ReleaseNotesModal.vue?vue&type=script&lang=ts&"
export * from "./ReleaseNotesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports